import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  contextImageViewContainer: {
    height: '302px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    gap: '12px',
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), url(https://cdn.prod.website-files.com/64b616355709d8b7b20535ac/67a453b52e2432b13c264482_img_bg_llm.webp)',
    backgroundSize: 'cover',
    backgroundPosition: 'center 25%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'lightgray',
  },
  pageContext: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    margin: 'auto',
  },
  pageTitle: {
    color: '#FFFFFF',
    textAlign: 'center',
    fontFamily: tokens.fontFamilyBase,
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    textTransform: 'uppercase',
  },
  pageSubTitle: {
    alignSelf: 'stretch',
    color: '#FFFFFF',
    textAlign: 'center',
    fontFamily: tokens.fontFamilyBase,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    opacity: 0.5,
  },
});
